// extracted by mini-css-extract-plugin
module.exports = {"table":"CustomerList_table__34nfZ","modal":"CustomerList_modal__3Hsfa","filters":"CustomerList_filters__1NsMf"};